'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: '请选择时间'
};

exports['default'] = locale;